import { render } from "./TournamentMobilePayments.vue?vue&type=template&id=3e5f437a&scoped=true"
const script = {}

import "./TournamentMobilePayments.vue?vue&type=style&index=0&id=3e5f437a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5f437a"]])

export default __exports__